import { inject } from 'aurelia-framework';
import { DialogController } from 'aurelia-dialog';

@inject(DialogController)
export class Lightbox {
    constructor(controller) {
        this.controller = controller;
    }

    activate(message) {
        this.title = message.title;
        this.paragraphs = message.paragraphs;
        this.infoOnly = message.infoOnly;
        this.links = message.links;

        this.button1 = message.button1 ? message.button1 : 'Save changes';
        this.button2 = message.button2 ? message.button2 : "Don't Save";
    }
}
